/**
 * @file 资料块内容
 */
import styled from 'styled-components'

import { RichTextRenderer } from 'packages/components/RichText'
import { RichTextEditor } from 'packages/components/RichText/Editor'
import { BlockStateEnum } from 'packages/feature-utils/test-paper'

import { BlockComponent } from '../../BlockWrapper/types'

/**
 * 资料块内容
 *
 * @param {BlockProps} props - BlockProps
 * @returns MaterialBlock
 */
export const MaterialBlock: BlockComponent = ({
  state,
  onChangeState,
  blockData,
  onChangeBlockData,
  onSave,
}) => {
  const renderContent = () => {
    if (state !== BlockStateEnum.Editing) {
      return (
        <RendererWrapper
          onClick={() => {
            onChangeState(BlockStateEnum.Selected)
          }}
          onDoubleClick={() => {
            onChangeState(BlockStateEnum.Editing)
          }}
        >
          <RichTextRenderer value={blockData.content || ''} />
        </RendererWrapper>
      )
    }

    return (
      <RichTextEditor
        value={blockData.content || ''}
        onChange={(s) => {
          onChangeBlockData({ ...blockData, content: s })
        }}
        minHeight={104}
        autoFocus={true}
        useFullScreen={false}
        onEditorBlur={async (e) => {
          /*
           * 1. 触发 onblur 的元素为子元素（包含 editor 本体）
           * 2. 且下一个 focus 的元素为空时（排除上传图片/文件时触发失焦）
           * 触发保存
           */
          if (
            e.currentTarget.contains(e.target) &&
            e.relatedTarget &&
            !e.currentTarget.contains(e.relatedTarget)
          ) {
            onChangeState(BlockStateEnum.Display)
            await onSave()
          }
        }}
      />
    )
  }

  return <div>{renderContent()}</div>
}

const RendererWrapper = styled.div`
  padding: 8px 16px 8px 22px;
`
